
import React, { useEffect, useState } from 'react';
import {
  Box, SimpleGrid, Stat, StatLabel, StatNumber,
  Text, Flex, Card, CardBody, Spinner,
} from '@chakra-ui/react';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend
} from 'recharts';
import axios from 'axios';

const DashboardUrbanizacion = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-urbanizacion`);
        setData(response.data);
      } catch (error) {
        console.error('Error al cargar datos:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const total = data.length;
  const totalCosto = data.reduce((acc, curr) => acc + (parseFloat(curr.costo) || 0), 0);
  const desarrollos = [...new Set(data.map(d => d.tipoDesarrollo))];

  const grouped = desarrollos.map(tipo => {
    const count = data.filter(item => item.tipoDesarrollo === tipo).length;
    return { name: tipo, value: count };
  });

  const colors = ['#4FD1C5', '#63B3ED', '#F6AD55', '#FC8181', '#90CDF4', '#F56565'];

  if (loading) {
    return (
      <Box p={6} textAlign="center">
        <Spinner size="xl" />
      </Box>
    );
  }

  return (
    <Box p={6}>
      <Text fontSize="2xl" fontWeight="bold" mb={4}>Dashboard de Urbanización</Text>
      <Flex justify="center" mb={6}>
 


        <Card flexBasis={{ base: '100%', md: '400px' }} boxShadow="none">
          <CardBody>
            <Text fontWeight="bold" mb={4} textAlign="center">
              Distribución por Tipo de Desarrollo
            </Text>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={grouped}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label
                >
                  {grouped.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </CardBody>
        </Card>
      </Flex>

      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4} flex={1}>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Total de Solicitudes</StatLabel>
            <StatNumber>{total}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Tipos de Desarrollo</StatLabel>
            <StatNumber>{desarrollos.length}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Total Ingresos</StatLabel>
            <StatNumber>${totalCosto.toFixed(2)}</StatNumber>
          </Stat>
        </SimpleGrid>
    </Box>
  );
};

export default DashboardUrbanizacion;